import React from 'react';
import './send-invoice-success-content.scss';
import { SVGS } from '../../assets/svgs';
import {
  APP_TYPE,
  getAppType,
  getCustomerInvite,
  getSelectedItemIds,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { CommonButton } from '../../components';
import { onClickBackToWhatsapp } from '../../helper';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../constants';
import { useNavigate } from 'react-router-dom';

interface SendInvoiceSuccessContentProps {
  btnText?: string;
  btnAction?: () => void;
  successHeading?: string;
  successDescription?: string;
}

export const SendInvoiceSuccessDrawer: React.FC<
  SendInvoiceSuccessContentProps
> = ({
  btnText = 'Go To WhatsApp',
  btnAction,
  successHeading = '',
  successDescription = '',
}) => {
  const appType = useAppSelector(getAppType);
  const navigate = useNavigate();
  const sentInvoices = useAppSelector(getSelectedItemIds);
  const inviteDetails = useAppSelector(getCustomerInvite);

  const { seller, waConfig } = inviteDetails;

  const handleGoToWhatsAppClick = () => {
    const navigationRoute =
      appType === APP_TYPE.FIELDS_OPS ? FIELD_OPS_ROUTES : SELLER_WEBAPP_ROUTES;

    navigate(navigationRoute.INVOICES_LIST);
    onClickBackToWhatsapp({
      whatsappPhoneNo: waConfig?.whatsappPhoneNo,
      workspaceId: seller?.workspaceId,
    });
  };

  return (
    <div className="send-invoice-success-drawer">
      <div className="send-invoice-success-drawer-content">
        <div className="send-invoice-success-drawer-content-wrapper">
          <div className="send-invoice-success-drawer-content-wrapper-success-icon">
            <img
              src={SVGS.SuccesIcon}
              width={120}
              height={120}
              alt="send success icon"
            />
          </div>
          <div className="send-invoice-success-drawer-content-wrapper-text">
            <span className="send-invoice-success-drawer-content-wrapper-text-title font-semibold">
              {successHeading || 'Invoice Sent Successfully!'}
            </span>
            <span className="send-invoice-success-drawer-content-wrapper-text-description font-regular">
              {successDescription ||
                `${sentInvoices?.length} Invoice${
                  sentInvoices?.length > 1 ? 's have' : ' has'
                } been sent successfully`}
            </span>
          </div>
        </div>
        <CommonButton
          text={btnText}
          buttonStyle="send-invoice-success-drawer-content-button"
          onPress={() => {
            if (btnAction) {
              btnAction();
            } else {
              handleGoToWhatsAppClick();
            }
          }}
          textStyle="send-invoice-success-drawer-content-button-text font-semibold"
        />
      </div>
    </div>
  );
};
